import React, { Component } from 'react'
import { Button, Header, Icon, Modal } from 'semantic-ui-react'
import Listimages from './list-uploaded-images';


class Selectimages extends Component {
  state = { modalOpen: false }

  handleOpen = () => this.setState({ modalOpen: true })

  handleClose = () => this.setState({ modalOpen: false })

  render() {
    return (
      <Modal
        trigger={<Button onClick={this.handleOpen}>Select Image</Button>}
        open={this.state.modalOpen}
        onClose={this.handleClose}
        // basic
        size='large'
      >
        <Header icon='browser' content='Select image for aerial view' />
        <Modal.Content>
          <Listimages />
        </Modal.Content>
        <Modal.Actions>
          <Button color='green' onClick={this.handleClose} inverted>
            <Icon name='checkmark' /> Done
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}

export default Selectimages;;